import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'access/',
    name: 'Access',
    component: () => import('~/views/access/AccessMain.vue'),
    meta: {
      title: 'Доступы'
    }
  },
  {
    path: 'access/users',
    name: 'Access.Users',
    component: () => import('~/views/access/lists/UserList.vue'),
    meta: {
      title: 'Пользователи'
    }
  },
  {
    path: 'access/users/detail/:id?',
    name: 'Access.User',
    component: () => import('~/views/access/list-items/UserDetails.vue'),
    meta: {
      title: 'Пользователь'
    }
  },
  {
    path: 'access/users-ads',
    name: 'Access.AdsUsers',
    component: () => import('~/views/access/lists/AdsUsers.vue'),
    meta: {
      title: 'Пользователи АДС'
    }
  },
  {
    path: 'access/users-ads/detail/:id?',
    name: 'Access.AdsUser',
    component: () => import('~/views/access/list-items/AdsUser.vue'),
    meta: {
      title: 'Пользователь АДС'
    }
  },
  {
    path: 'access/roles',
    name: 'Access.Roles',
    component: () => import('~/views/access/lists/RoleList.vue'),
    meta: {
      title: 'Роли сотрудников в базе'
    }
  },
  {
    path: 'access/roles/detail/:id?',
    name: 'Access.Role',
    component: () => import('~/views/access/list-items/RoleDetails.vue'),
    meta: {
      title: 'Роль сотрудника в базе'
    }
  },

  // Dependent pages
  {
    path: 'access/users/detail/:parentId/roof-users-roles',
    name: 'RoofUserRolesForAccount',
    component: () => import('~/views/access/lists/RoofUserRolesForAccount.vue'),
    meta: { title: 'Роли назначенные пользователям в базе' }
  },
  {
    path: 'access/users/detail/:parentId/roof-users-roles/detail/:id?',
    name: 'RoofUserRoleForAccount',
    component: () => import('~/views/access/list-items/RoofUserRoleForAccount.vue'),
    meta: { title: 'Роли назначенные пользователям в базе' }
  }
];